'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  overflow: 'hidden',
  zIndex: -1,
  visibility: 'hidden',
  pointerEvents: 'none'
};
var styleChild = {
  position: 'absolute',
  left: 0,
  top: 0,
  transition: '0s'
};

var ResizeSensor = function (_Component) {
  _inherits(ResizeSensor, _Component);

  function ResizeSensor() {
    _classCallCheck(this, ResizeSensor);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ResizeSensor).apply(this, arguments));
  }

  _createClass(ResizeSensor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onResize();
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      var target = _reactDom2.default.findDOMNode(this);
      this.props.onResize({
        width: target.offsetWidth,
        height: target.offsetHeight
      });
    }
  }, {
    key: 'onScroll',
    value: function onScroll(ev) {
      var el = ev.target;
      var cachedWidth = el.offsetWidth;
      var cachedHeight = el.offsetHeight;
      if (cachedWidth !== this.lastWidth || cachedHeight !== this.lastHeight) {
        this.onResize();
        this.lastWidth = cachedWidth;
        this.lastHeight = cachedHeight;
      }
      this.reset(el);
    }
  }, {
    key: 'reset',
    value: function reset(el) {
      el.scrollLeft = 100000;
      el.scrollTop = 100000;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return (0, _react.createElement)(
        'div',
        { style: style },
        (0, _react.createElement)(
          'div',
          {
            style: style,
            onScroll: function onScroll(ev) {
              return _this2.onScroll(ev);
            },
            ref: function ref(el) {
              return el ? _this2.reset(el) : null;
            }
          },
          (0, _react.createElement)('div', { style: _extends({}, styleChild, { width: 100000, height: 100000 }) })
        ),
        (0, _react.createElement)(
          'div',
          {
            style: style,
            onScroll: function onScroll(ev) {
              return _this2.onScroll(ev);
            },
            ref: function ref(el) {
              return el ? _this2.reset(el) : null;
            }
          },
          (0, _react.createElement)('div', { style: _extends({}, styleChild, { width: '200%', height: '200%' }) })
        )
      );
    }
  }]);

  return ResizeSensor;
}(_react.Component);

ResizeSensor.defaultProps = {
  onResize: function onResize() {}
};
exports.default = ResizeSensor;
//# sourceMappingURL=resized.js.map